import { defineStore } from "pinia";

export const usePortStore = defineStore("PortStore", {
  state: () => ({
    ports: [],
  }),
  getters: {},
  actions: {
    async getPort(token) {
      if (!token) {
        this.ports = [];
        return null;
      }
      try {
        const res = await $fetch("/api/port/get-port", {
          method: "POST",
          body: { token },
        });
        this.ports = res?.data?.[0]?.ports ?? [];
        return res;
      } catch (error) {
        console.error("API error:", error);
        this.ports = [];
        return null;
      }
    },

    async getToken() {
      try {
        const res = await $fetch("/api/port/get-token", {
          method: "POST",
        });
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },
  },
});
